export interface FoodSwap {
  from: {
    name: string;
    calories: number;
    emoji: string;
  };
  to: {
    name: string;
    calories: number;
    emoji: string;
  };
}

export const foodSwaps: FoodSwap[] = [
  {
    from: {
      name: "Kung Pao Chicken",
      calories: 780,
      emoji: "🥡"
    },
    to: {
      name: "Grilled Chicken Salad",
      calories: 320,
      emoji: "🥗"
    }
  },
  {
    from: {
      name: "Butter Chicken",
      calories: 490,
      emoji: "🍗"
    },
    to: {
      name: "Tandoori Chicken",
      calories: 240,
      emoji: "🍗"
    }
  },
  {
    from: {
      name: "Sushi Roll",
      calories: 350,
      emoji: "🍱"
    },
    to: {
      name: "Sashimi",
      calories: 180,
      emoji: "🐟"
    }
  },
  {
    from: {
      name: "Pizza Slice",
      calories: 285,
      emoji: "🍕"
    },
    to: {
      name: "Cauliflower Pizza",
      calories: 145,
      emoji: "🥗"
    }
  },
  {
    from: {
      name: "Ice Cream Sundae",
      calories: 420,
      emoji: "🍨"
    },
    to: {
      name: "Greek Yogurt with Berries",
      calories: 180,
      emoji: "🫐"
    }
  },
  {
    from: {
      name: "Pancakes with Syrup",
      calories: 520,
      emoji: "🥞"
    },
    to: {
      name: "Oatmeal with Fruit",
      calories: 220,
      emoji: "🥣"
    }
  },
  {
    from: {
      name: "Fried Rice",
      calories: 580,
      emoji: "🍚"
    },
    to: {
      name: "Cauliflower Rice Stir-Fry",
      calories: 180,
      emoji: "🥦"
    }
  },
  {
    from: {
      name: "Cheeseburger",
      calories: 650,
      emoji: "🍔"
    },
    to: {
      name: "Turkey Burger with Lettuce Wrap",
      calories: 280,
      emoji: "🥬"
    }
  },
  {
    from: {
      name: "French Fries",
      calories: 420,
      emoji: "🍟"
    },
    to: {
      name: "Baked Sweet Potato Wedges",
      calories: 160,
      emoji: "🍠"
    }
  },
  {
    from: {
      name: "Mac & Cheese",
      calories: 350,
      emoji: "🧀"
    },
    to: {
      name: "Zucchini Noodles with Pesto",
      calories: 150,
      emoji: "🥒"
    }
  }
];